module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fma1"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Contributors"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("List of Contributors")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Part01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SECTION ONE: THE MEDIEVAL PERIOD")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Peasants’ Revolt of 1381")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Stephen Basdeo")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Gentlemen of the Jack Cade Rebellion")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Alexander L. Kaufman")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SECTION TWO: THE ENGLISH REVOLUTION")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Oliver Cromwell and John Lilburne")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Sheldon Goldfarb")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Levellers")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Joseph Saunders")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sects and Dissenters of the English Revolution")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Joseph Saunders")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SECTION THREE: THE EIGHTEENTH CENTURY")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Thomas Paine")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Frances Chiu")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Radicalism in the Mid-to-Late Eighteenth Century")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Stephen Basdeo")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mary Wollstonecraft")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Rebecca Nesvet")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SECTION FOUR: THE NINETEENTH CENTURY")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Peterloo Massacre")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Sam Quill")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The “Great” Reform Act of 1832")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Stephen Basdeo")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chartism")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Rebecca Nesvet")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Politics in “The Age of Equipoise”")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Angelo Calfo and Stephen Basdeo")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("William Morris: From Design Reform to Radical Politics")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Anne Anderson")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The British Campaign for ‘Votes for Women’, 1865-1928")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Di Drummond")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Epilogue")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Select Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132b06ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 69
// module chunks = 0